import { ROUTES } from './routes'

/**
 * F-89: `/admin/communities/requests` (the Pedidos tab of Comunidades) and
 * `/admin/communities/requests/{id}` (the detail). Static pages, never a space route.
 * The old `/admin/community-requests…` paths redirect here (`routes.js`).
 */
export const isAdminCommunityRequestsPath = (path: string): boolean => {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '')
  return pathname === ROUTES.adminCommunityRequests || pathname.startsWith(ROUTES.adminCommunityRequests + '/')
}

/** The request id of a detail path; `null` on the list. */
export const adminCommunityRequestIdOf = (path: string): string | null => {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '')
  if (!pathname.startsWith(ROUTES.adminCommunityRequests + '/')) return null
  const id = decodeURIComponent(pathname.slice(ROUTES.adminCommunityRequests.length + 1).split('/')[0] || '')
  return id || null
}

export const adminCommunityRequestPath = (id: string): string => `${ROUTES.adminCommunityRequests}/${encodeURIComponent(id)}`
